<template>
  <v-list-item two-line>
    <v-list-item-content>
      <v-row class="d-flex align-center">
        <v-col sm="8">
          <p class="accountName ma-0 pa-0">{{ name }}</p>
          <p v-if="companyName" class="accountCompanyName ma-0 pa-0">{{ companyName }}</p>
        </v-col>
        <v-spacer></v-spacer>
        <v-col sm="2">
          <v-btn
            color="#F20732"
            width="120"
            height="40"
            outlined
            @click="blocked ? unblockUser() : blockUser()"
          >{{ blocked ? 'Desbloquear' : 'Bloquear'}}</v-btn>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    blockUser() {
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/api/admin/block-user`,
          { _id: this.id },
          {
            headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
          }
        )
        .then(() => {
          axios
            .get(`${process.env.VUE_APP_API_URL}/api/admin/webapp`, {
              headers: {
                Authorization: `Bearer ${this.$store.state.user.token}`
              }
            })
            .then(res => {
              this.$store.dispatch("setAccounts", {
                accounts: res.data.data.users
              });
            });
        })
        .catch(error => console.log(error));
    },
    unblockUser() {
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/api/admin/unblock-user`,
          { _id: this.id },
          {
            headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
          }
        )
        .then(() => {
          axios
            .get(`${process.env.VUE_APP_API_URL}/api/admin/webapp`, {
              headers: {
                Authorization: `Bearer ${this.$store.state.user.token}`
              }
            })
            .then(res => {
              this.$store.dispatch("setAccounts", {
                accounts: res.data.data.users
              });
            });
        })
        .catch(error => console.log(error));
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    companyName: {
      type: String,
      required: false
    },
    blocked: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.accountName {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.5px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}

.accountCompanyName {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}
</style>